import { createApp } from 'vue'
import { createI18n } from 'vue-i18n';
import router from "./router";
import store from './store';
import App from "./app.vue";
import axios from 'axios';
import VueKeyCloak from '@dsb-norge/vue-keycloak-js'
import VueLogger from 'vuejs3-logger';
import useUtils from './components/hooks/useUtils';
import { registerLicense } from '@syncfusion/ej2-base';

const { sleep, getUserLocale } = useUtils();

const i18n = createI18n({
    messages: messages,
    locale: getUserLocale(locale, store.getters['user/locales']),
    fallbackLocale: locale.fallback_locale
});

/*if (kc_options && kc_options.init.onLoad == 'check-sso') {
    kc_options.silentCheckSsoRedirectUri = window.location.origin + "/silent-check-sso.html"
}*/

const kc_config = {
    config: kc_options.config,
    init: kc_options.init,
    onReady(keycloak) {
        tokenInterceptor(keycloak);
        app.mount('#app');
    },
    onInitError(error, err) {
        console.log("Authorization Server Error: " + err);
        console.log(error);
        sleep(1000);
    },
}

function tokenInterceptor(keycloak) {
    axios.interceptors.request.use(
        config => {
            if (keycloak.authenticated) {
                config.headers.common.Authorization = `Bearer ${keycloak.token}`;
            }
            return config;
        },
        error => {
            // console.log("error=" + error);
            return Promise.reject(error)
        }
    )
}

const isProduction = process.env.NODE_ENV === 'production';
const logger_options = {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
};

registerLicense('Ngo9BigBOggjHTQxAR8/V1NCaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdnWXZfc3RRQ2RdU0Z1WEs=')

const app = createApp(App);
app.config.globalProperties.window = window;
app.use(router).use(store).use(i18n).use(VueLogger, logger_options).use(VueKeyCloak, kc_config);
router.app = app;
require('./bootstrap');

export default app;